export const GET_CARDS_SUCCESSFUL = 'GET_CARDS_SUCCESSFUL'
export const GET_CARDS_FAILED = 'GET_CARDS_FAILED'
export const MAKE_CARD_DEFAULT_SUCCESSFUL = 'MAKE_CARD_DEFAULT_SUCCESSFUL'
export const MAKE_CARD_DEFAULT_FAILED = 'MAKE_CARD_DEFAULT_FAILED'
export const CREATE_CARD_SUCCESSFUL = 'CREATE_CARD_SUCCESSFUL'
export const CREATE_CARD_FAILED = 'CREATE_CARD_FAILED'
export const DELETE_CARD_SUCCESSFUL = 'DELETE_CARD_SUCCESSFUL'
export const DELETE_CARD_FAILED = 'DELETE_CARD_FAILED'